import { StyledContent } from '@/components/styles'
import { Feature } from '@/components'

const TitleAdvantages = ({ data }) => {
  const { advantages } = data

  return (
    <StyledContent.Features>
      {advantages.map(advantage => {
        const { id, ...props } = advantage
        return <Feature key={id} as="li" {...props} />
      })}
    </StyledContent.Features>
  )
}

export default TitleAdvantages
